import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=50d5296e&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d5296e')) {
      api.createRecord('50d5296e', component.options)
    } else {
      api.reload('50d5296e', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=50d5296e&", function () {
      api.rerender('50d5296e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rxIEZcSWfUCV/JS/comp/ImageCarousel.vue"
export default component.exports